import React,{useEffect} from 'react';
import Image from 'next/image';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { parseShopifyHost } from '../utils/parseShopifyHost';
import { redirect } from 'next/dist/server/api-utils';

export const Topbar = ({ onSubscriptionOpen}) => {
  const storeLimitData = useSelector((state)=>state.storeLimit?.data);
  const isTrail = useSelector((state)=> state.storeLimit?.isTrail);
  const isTrailWebApp = useSelector((state)=> state.storeLimit?.isTrailWebApp);
  const trailDetails = useSelector((state)=>state.storeLimit?.trailDetails);
  const planDetails = useSelector((state)=>state.storeLimit?.planDetails);
  const isPlanExist = useSelector((state)=>state.storeLimit?.isPlanExist);

  const { isShopifyApp, shopName  } = parseShopifyHost();

  const renderCreditsInfo = () => {
    // If storeLimit is empty or doesn't exist, don't show anything
    if (!storeLimitData || Object.keys(storeLimitData).length === 0) {
      return null;
    }

    // For Trial plans
    if (isShopifyApp) {
      const totalCredits = parseInt(trailDetails?.allowedCredit, 10) || 0;
      const consumedCredits = parseInt(trailDetails?.usedCredit, 10) || 0;
      const remainingCredits = totalCredits - consumedCredits;
      const remaningdays = parseInt(storeLimitData?.remainingTrialDays, 10) || 0;
      const availablecredits = parseInt(storeLimitData?.remainingCredits, 10) || 0;

      // Credits exhausted case
      if((remaningdays <= 0 && availablecredits <= 0)) {
        return (
          <span className="d-inline-flex fw-medium" >
            <span className="status-badge">
              Limits exhausted, select a plan to continue
            </span>
          </span>
        );
      }else if(remaningdays>0 && availablecredits<=0){
        return (
          <span className="d-inline-flex fw-medium" >
            <span className="status-badge">
              Limits exhausted, please contact <a style={{paddingLeft:"5px"}}> sales@striketru.com</a>
            </span>
          </span>
        );
      }
      else if (remaningdays > 0 && availablecredits > 0){
        return (
  
          <div className="d-flex justify-content-end align-items-center gap-3 w-100">
                <span className="status-badge">
                  Trail: {remaningdays} days left
                </span>
                <span className="status-badge">
                  Products Synced: {consumedCredits}/{totalCredits}
                </span>
          </div> 
        );
      }

      // Normal case with credits remaining
    }else{
      const totalCredits = parseInt(trailDetails?.allowedCredit, 10) || 0;
      const consumedCredits = parseInt(trailDetails?.usedCredit, 10) || 0;
      const remainingCredits = totalCredits - consumedCredits;
      const remaningdays = parseInt(storeLimitData?.remainingTrialDays, 10) || 0;
      const availablecredits = parseInt(storeLimitData?.remainingCredits, 10) || 0;
      if(isTrailWebApp && remainingCredits > 0){
        return <div className="d-flex justify-content-end align-items-center gap-3 w-100">
            {(!isShopifyApp &&
              <span className="status-badge">
              Products Synced: {consumedCredits}/{totalCredits}
              </span>
            )}
        </div> 
      }else if(isTrailWebApp && remainingCredits <= 0){
        return (
          <span className="d-inline-flex fw-medium" >
            <span className="status-badge">
              Credits Exhausted, Contact {" "}
              <a
                className="text-decoration-underline hover:text-danger-emphasis"
                style={{paddingLeft: "5px"}}
              >
                sales@striketru.com.
              </a>
            </span>
          </span>
        )
    }
    }

    return null;
  };

  return (
    <div className="TopBar">
      <div className="container my-4">
        <div className="row align-items-center">
          <div className="col-8">
            <Image
              src="/images/StrikeTru_Logo.png"
              alt="Striketru Logo"
              priority
              width={210}
              height={35}
              className="rounded"
            />
          </div>
          <div className="col-3 d-flex justify-content-end align-items-center gap-3">
            {renderCreditsInfo()}
            <div>
              <div className="d-flex justify-content-end align-items-center gap-3 w-100">
                <Button
                  onClick={onSubscriptionOpen}
                  variant="outline-dark"
                  className="stru-btn-secondary"
                >
                  Change Plan
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
